import { useEffect, useState } from 'react';
import {
  AUDIO_QUEUE_CHANGED_EVENT,
  getQueuedDocIds,
} from '@/utils/audioUploadQueue';

/**
 * 이 기기에 업로드하지 못한 녹음 백업이 남아 있는 문서 id (PORTAL-12583).
 * 목록의 「업로드 실패」 라벨에 쓴다. 백업은 브라우저(IndexedDB)에만 있어 서버 목록 응답으론 알 수 없다.
 * 같은 탭의 큐 변경 · 창 포커스(다른 탭에서 복구했을 수 있음) 때 다시 읽는다.
 */
const useQueuedRecordDocIds = (): Set<string> => {
  const [docIds, setDocIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    let alive = true;
    const load = () => {
      getQueuedDocIds()
        .then((ids) => {
          if (alive) setDocIds(ids);
        })
        .catch(console.error);
    };
    load();
    window.addEventListener(AUDIO_QUEUE_CHANGED_EVENT, load);
    window.addEventListener('focus', load);
    return () => {
      alive = false;
      window.removeEventListener(AUDIO_QUEUE_CHANGED_EVENT, load);
      window.removeEventListener('focus', load);
    };
  }, []);

  return docIds;
};

export default useQueuedRecordDocIds;
